(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kvision-js-legacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kvision-js-legacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-chart-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-chart-js-legacy'.");
    }if (typeof this['kvision-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-chart-js-legacy'. Its dependency 'kvision-js-legacy' was not found. Please, check whether 'kvision-js-legacy' is loaded prior to 'kvision-kvision-chart-js-legacy'.");
    }root['kvision-kvision-chart-js-legacy'] = factory(typeof this['kvision-kvision-chart-js-legacy'] === 'undefined' ? {} : this['kvision-kvision-chart-js-legacy'], kotlin, this['kvision-js-legacy']);
  }
}(this, function (_, Kotlin, $module$kvision_js_legacy) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var ModuleInitializer = $module$kvision_js_legacy.io.kvision.ModuleInitializer;
  var Enum = Kotlin.kotlin.Enum;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var throwISE = Kotlin.throwISE;
  var Widget = $module$kvision_js_legacy.io.kvision.core.Widget;
  var getCallableRef = Kotlin.getCallableRef;
  var ensureNotNull = Kotlin.ensureNotNull;
  var Unit = Kotlin.kotlin.Unit;
  var i18n = $module$kvision_js_legacy.io.kvision.i18n;
  var equals = Kotlin.equals;
  var createInstance = $module$kvision_js_legacy.io.kvision.utils.createInstance_aevmdv$;
  var Canvas = $module$kvision_js_legacy.io.kvision.html.Canvas;
  var throwCCE = Kotlin.throwCCE;
  var Object_init = Object;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  var copyToArray = Kotlin.kotlin.collections.copyToArray;
  Chart.prototype = Object.create(Widget.prototype);
  Chart.prototype.constructor = Chart;
  ChartCanvas.prototype = Object.create(Canvas.prototype);
  ChartCanvas.prototype.constructor = ChartCanvas;
  ChartType.prototype = Object.create(Enum.prototype);
  ChartType.prototype.constructor = ChartType;
  function ChartModule() {
    ChartModule_instance = this;
    this.chartjs_0 = require('chart.js/auto').default;
  }
  ChartModule.prototype.getConstructor = function () {
    return this.chartjs_0;
  };
  ChartModule.prototype.initialize = function () {
  };
  ChartModule.$metadata$ = {kind: Kind_OBJECT, simpleName: 'ChartModule', interfaces: [ModuleInitializer]};
  var ChartModule_instance = null;
  function ChartModule_getInstance() {
    if (ChartModule_instance === null) {
      new ChartModule();
    }return ChartModule_instance;
  }
  var UpdateMode$ACTIVE_instance;
  var UpdateMode$HIDE_instance;
  var UpdateMode$RESET_instance;
  var UpdateMode$RESIZE_instance;
  var UpdateMode$SHOW_instance;
  var UpdateMode$NONE_instance;
  function Chart(configuration, chartWidth, chartHeight, className, init) {
    Chart$Companion_getInstance();
    if (chartWidth === void 0)
      chartWidth = null;
    if (chartHeight === void 0)
      chartHeight = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Widget.call(this, className);
    this.chartCanvas_8be2vx$ = new ChartCanvas(chartWidth, chartHeight, configuration);
    init != null ? init(this) : null;
  }
  Object.defineProperty(Chart.prototype, 'configuration', {configurable: true, get: function () {
    return this.chartCanvas_8be2vx$.configuration;
  }, set: function (value) {
    this.chartCanvas_8be2vx$.configuration = value;
  }});
  Object.defineProperty(Chart.prototype, 'jsChart', {configurable: true, get: function () {
    return this.chartCanvas_8be2vx$.jsChart;
  }});
  Chart.prototype.render = function () {
    return this.render_pjwf99$('div', [this.chartCanvas_8be2vx$.renderVNode()]);
  };
  Chart.prototype.getNativeConfig = function () {
    return this.chartCanvas_8be2vx$.getNativeConfig();
  };
  Chart.prototype.reset = function () {
    this.chartCanvas_8be2vx$.reset();
  };
  Chart.prototype.renderChart = function () {
    this.chartCanvas_8be2vx$.renderChart();
  };
  Chart.prototype.stop = function () {
    this.chartCanvas_8be2vx$.stop();
  };
  Chart.prototype.resizeChart = function () {
    this.chartCanvas_8be2vx$.resizeChart();
  };
  Chart.prototype.clearChart = function () {
    this.chartCanvas_8be2vx$.clearChart();
  };
  Chart.prototype.update_lxfvj4$$default = function (updateMode) {
    this.chartCanvas_8be2vx$.update_lxfvj4$(updateMode);
  };
  Chart.prototype.update_lxfvj4$ = function (updateMode, callback$default) {
    if (updateMode === void 0)
      updateMode = null;
    callback$default ? callback$default(updateMode) : this.update_lxfvj4$$default(updateMode);
  };
  Chart.prototype.toBase64Image = function () {
    return this.chartCanvas_8be2vx$.toBase64Image();
  };
  function Chart$Companion() {
    Chart$Companion_instance = this;
    ChartModule_getInstance().initialize();
  }
  Chart$Companion.prototype.registerPlugin_za3rmp$ = function (plugin) {
    ChartModule_getInstance().getConstructor().register(plugin);
  };
  Chart$Companion.prototype.unregisterPlugin_za3rmp$ = function (plugin) {
    ChartModule_getInstance().getConstructor().unregister(plugin);
  };
  Chart$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Chart$Companion_instance = null;
  function Chart$Companion_getInstance() {
    if (Chart$Companion_instance === null) {
      new Chart$Companion();
    }return Chart$Companion_instance;
  }
  Chart.$metadata$ = {kind: Kind_CLASS, simpleName: 'Chart', interfaces: [Widget]};
  function ChartCanvas(canvasWidth, canvasHeight, configuration, className) {
    ChartCanvas$Companion_getInstance();
    if (canvasWidth === void 0)
      canvasWidth = null;
    if (canvasHeight === void 0)
      canvasHeight = null;
    if (className === void 0)
      className = null;
    Canvas.call(this, canvasWidth, canvasHeight, className);
    this.configuration_s7uvm7$_0 = configuration;
    this.jsChart = null;
    this.useSnabbdomDistinctKey();
  }
  Object.defineProperty(ChartCanvas.prototype, 'configuration', {configurable: true, get: function () {
    return this.configuration_s7uvm7$_0;
  }, set: function (value) {
    var tmp$, tmp$_0, tmp$_1;
    this.configuration_s7uvm7$_0 = value;
    var newConfig = toJs_22(value, getCallableRef('translate', function ($receiver, p1) {
      return $receiver.translate_61zpoe$(p1);
    }.bind(null, this)));
    if (newConfig.data != null)
      (tmp$ = this.jsChart) != null ? (tmp$.data = ensureNotNull(newConfig.data)) : null;
    if (newConfig.options != null)
      (tmp$_0 = this.jsChart) != null ? (tmp$_0.options = ensureNotNull(newConfig.options)) : null;
    (tmp$_1 = this.jsChart) != null ? (tmp$_1.update(), Unit) : null;
  }});
  ChartCanvas.prototype.render = function () {
    var tmp$, tmp$_0, tmp$_1;
    if (this.lastLanguage != null && !equals(this.lastLanguage, i18n.I18n.language)) {
      var newConfig = toJs_22(this.configuration, getCallableRef('translate', function ($receiver, p1) {
        return $receiver.translate_61zpoe$(p1);
      }.bind(null, this)));
      if (newConfig.data != null)
        (tmp$ = this.jsChart) != null ? (tmp$.data = ensureNotNull(newConfig.data)) : null;
      if (newConfig.options != null)
        (tmp$_0 = this.jsChart) != null ? (tmp$_0.options = ensureNotNull(newConfig.options)) : null;
      (tmp$_1 = this.jsChart) != null ? (tmp$_1.update(), Unit) : null;
    }return this.render_61zpoe$('canvas');
  };
  ChartCanvas.prototype.afterInsert_77isfd$ = function (node) {
    this.jsChart = createInstance(ChartModule_getInstance().getConstructor(), [this.context2D, toJs_22(this.configuration, getCallableRef('translate', function ($receiver, p1) {
      return $receiver.translate_61zpoe$(p1);
    }.bind(null, this)))]);
  };
  ChartCanvas.prototype.afterDestroy = function () {
    var tmp$;
    (tmp$ = this.jsChart) != null ? (tmp$.destroy(), Unit) : null;
    this.jsChart = null;
  };
  ChartCanvas.prototype.getNativeConfig = function () {
    var tmp$;
    return (tmp$ = this.jsChart) != null ? tmp$.config : null;
  };
  ChartCanvas.prototype.reset = function () {
    var tmp$;
    (tmp$ = this.jsChart) != null ? (tmp$.reset(), Unit) : null;
  };
  ChartCanvas.prototype.renderChart = function () {
    var tmp$;
    (tmp$ = this.jsChart) != null ? (tmp$.render(), Unit) : null;
  };
  ChartCanvas.prototype.stop = function () {
    var tmp$;
    (tmp$ = this.jsChart) != null ? tmp$.stop() : null;
  };
  ChartCanvas.prototype.resizeChart = function () {
    var tmp$;
    (tmp$ = this.jsChart) != null ? (tmp$.resize(), Unit) : null;
  };
  ChartCanvas.prototype.clearChart = function () {
    var tmp$;
    (tmp$ = this.jsChart) != null ? tmp$.clear() : null;
  };
  ChartCanvas.prototype.update_lxfvj4$ = function (updateMode) {
    if (updateMode === void 0)
      updateMode = null;
    var tmp$;
    (tmp$ = this.jsChart) != null ? (tmp$.update(updateMode != null ? updateMode : undefined), Unit) : null;
  };
  ChartCanvas.prototype.toBase64Image = function () {
    var tmp$;
    return (tmp$ = this.jsChart) != null ? tmp$.toBase64Image() : null;
  };
  function ChartCanvas$Companion() {
    ChartCanvas$Companion_instance = this;
    ChartModule_getInstance().initialize();
  }
  ChartCanvas$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var ChartCanvas$Companion_instance = null;
  function ChartCanvas$Companion_getInstance() {
    if (ChartCanvas$Companion_instance === null) {
      new ChartCanvas$Companion();
    }return ChartCanvas$Companion_instance;
  }
  ChartCanvas.$metadata$ = {kind: Kind_CLASS, simpleName: 'ChartCanvas', interfaces: [Canvas]};
  function ChartType(name, ordinal, type) {
    Enum.call(this);
    this.type_8be2vx$ = type;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function ChartType_initFields() {
    ChartType_initFields = function () {
    };
    ChartType$LINE_instance = new ChartType('LINE', 0, 'line');
    ChartType$BAR_instance = new ChartType('BAR', 1, 'bar');
    ChartType$RADAR_instance = new ChartType('RADAR', 2, 'radar');
    ChartType$DOUGHNUT_instance = new ChartType('DOUGHNUT', 3, 'doughnut');
    ChartType$PIE_instance = new ChartType('PIE', 4, 'pie');
    ChartType$POLARAREA_instance = new ChartType('POLARAREA', 5, 'polarArea');
    ChartType$BUBBLE_instance = new ChartType('BUBBLE', 6, 'bubble');
    ChartType$SCATTER_instance = new ChartType('SCATTER', 7, 'scatter');
  }
  var ChartType$LINE_instance;
  function ChartType$LINE_getInstance() {
    ChartType_initFields();
    return ChartType$LINE_instance;
  }
  var ChartType$BAR_instance;
  function ChartType$BAR_getInstance() {
    ChartType_initFields();
    return ChartType$BAR_instance;
  }
  var ChartType$RADAR_instance;
  function ChartType$RADAR_getInstance() {
    ChartType_initFields();
    return ChartType$RADAR_instance;
  }
  var ChartType$DOUGHNUT_instance;
  function ChartType$DOUGHNUT_getInstance() {
    ChartType_initFields();
    return ChartType$DOUGHNUT_instance;
  }
  var ChartType$PIE_instance;
  function ChartType$PIE_getInstance() {
    ChartType_initFields();
    return ChartType$PIE_instance;
  }
  var ChartType$POLARAREA_instance;
  function ChartType$POLARAREA_getInstance() {
    ChartType_initFields();
    return ChartType$POLARAREA_instance;
  }
  var ChartType$BUBBLE_instance;
  function ChartType$BUBBLE_getInstance() {
    ChartType_initFields();
    return ChartType$BUBBLE_instance;
  }
  var ChartType$SCATTER_instance;
  function ChartType$SCATTER_getInstance() {
    ChartType_initFields();
    return ChartType$SCATTER_instance;
  }
  ChartType.$metadata$ = {kind: Kind_CLASS, simpleName: 'ChartType', interfaces: [Enum]};
  function ChartType$values() {
    return [ChartType$LINE_getInstance(), ChartType$BAR_getInstance(), ChartType$RADAR_getInstance(), ChartType$DOUGHNUT_getInstance(), ChartType$PIE_getInstance(), ChartType$POLARAREA_getInstance(), ChartType$BUBBLE_getInstance(), ChartType$SCATTER_getInstance()];
  }
  ChartType.values = ChartType$values;
  function ChartType$valueOf(name) {
    switch (name) {
      case 'LINE':
        return ChartType$LINE_getInstance();
      case 'BAR':
        return ChartType$BAR_getInstance();
      case 'RADAR':
        return ChartType$RADAR_getInstance();
      case 'DOUGHNUT':
        return ChartType$DOUGHNUT_getInstance();
      case 'PIE':
        return ChartType$PIE_getInstance();
      case 'POLARAREA':
        return ChartType$POLARAREA_getInstance();
      case 'BUBBLE':
        return ChartType$BUBBLE_getInstance();
      case 'SCATTER':
        return ChartType$SCATTER_getInstance();
      default:throwISE('No enum constant io.kvision.chart.ChartType.' + name);
    }
  }
  ChartType.valueOf_61zpoe$ = ChartType$valueOf;
  var InteractionMode$POINT_instance;
  var InteractionMode$NEAREST_instance;
  var InteractionMode$INDEX_instance;
  var InteractionMode$DATASET_instance;
  var InteractionMode$X_instance;
  var InteractionMode$Y_instance;
  var Eeasing$LINEAR_instance;
  var Eeasing$EASEINQUAD_instance;
  var Eeasing$EASEOUTQUAD_instance;
  var Eeasing$EASEINOUTQUAD_instance;
  var Eeasing$EASEINCUBIC_instance;
  var Eeasing$EASEOUTCUBIC_instance;
  var Eeasing$EASEINOUTCUBIC_instance;
  var Eeasing$EASEINQUART_instance;
  var Eeasing$EASEOUTQUART_instance;
  var Eeasing$EASEINOUTQUART_instance;
  var Eeasing$EASEINQUINT_instance;
  var Eeasing$EASEOUTQUINT_instance;
  var Eeasing$EASEINOUTQUINT_instance;
  var Eeasing$EASEINSINE_instance;
  var Eeasing$EASEOUTSINE_instance;
  var Eeasing$EASEINOUTSINE_instance;
  var Eeasing$EASEINEXPO_instance;
  var Eeasing$EASEOUTEXPO_instance;
  var Eeasing$EASEINOUTEXPO_instance;
  var Eeasing$EASEINCIRC_instance;
  var Eeasing$EASEOUTCIRC_instance;
  var Eeasing$EASEINOUTCIRC_instance;
  var Eeasing$EASEINELASTIC_instance;
  var Eeasing$EASEOUTELASTIC_instance;
  var Eeasing$EASEINOUTELASTIC_instance;
  var Eeasing$EASEINBACK_instance;
  var Eeasing$EASEOUTBACK_instance;
  var Eeasing$EASEINOUTBACK_instance;
  var Eeasing$EASEINBOUNCE_instance;
  var Eeasing$EASEOUTBOUNCE_instance;
  var Eeasing$EASEINOUTBOUNCE_instance;
  var Position$TOP_instance;
  var Position$LEFT_instance;
  var Position$RIGHT_instance;
  var Position$BOTTOM_instance;
  var Position$CENTER_instance;
  var Position$CHARTAREA_instance;
  var TooltipPosition$AVERAGE_instance;
  var TooltipPosition$NEAREST_instance;
  var PointStyle$CIRCLE_instance;
  var PointStyle$CROSS_instance;
  var PointStyle$CROSSROT_instance;
  var PointStyle$DASH_instance;
  var PointStyle$LINE_instance;
  var PointStyle$RECT_instance;
  var PointStyle$RECTROUNDED_instance;
  var PointStyle$RECTROT_instance;
  var PointStyle$START_instance;
  var PointStyle$TRIANGLE_instance;
  var InterpolationMode$DEFAULT_instance;
  var InterpolationMode$MONOTONE_instance;
  var ScalesType$CATEGORY_instance;
  var ScalesType$LINEAR_instance;
  var ScalesType$LOGARITHMIC_instance;
  var ScalesType$TIME_instance;
  var ScalesType$TIMESERIES_instance;
  var ScalesType$RADIALLINEAR_instance;
  var LineCap$BUTT_instance;
  var LineCap$ROUND_instance;
  var LineCap$SQUARE_instance;
  var LineJoin$BEVEL_instance;
  var LineJoin$ROUND_instance;
  var LineJoin$MITER_instance;
  var LegendAlign$CENTER_instance;
  var LegendAlign$END_instance;
  var LegendAlign$START_instance;
  var TooltipAlign$CENTER_instance;
  var TooltipAlign$LEFT_instance;
  var TooltipAlign$RIGHT_instance;
  var LegendLabelAlign$CENTER_instance;
  var LegendLabelAlign$LEFT_instance;
  var LegendLabelAlign$RIGHT_instance;
  var TitleAlign$CENTER_instance;
  var TitleAlign$LEFT_instance;
  var TitleAlign$RIGHT_instance;
  var TitleAlign$INNER_instance;
  var TextDirection$LTR_instance;
  var TextDirection$RTL_instance;
  var SkipMode$TOP_instance;
  var SkipMode$LEFT_instance;
  var SkipMode$RIGHT_instance;
  var SkipMode$BOTTOM_instance;
  var SkipMode$START_instance;
  var SkipMode$END_instance;
  var SkipMode$MIDDLE_instance;
  var BorderAlign$CENTER_instance;
  var BorderAlign$INNER_instance;
  var CrossAlign$CENTER_instance;
  var CrossAlign$NEAR_instance;
  var CrossAlign$FAR_instance;
  var ScaleBounds$DATA_instance;
  var ScaleBounds$TICKS_instance;
  function toJs($receiver) {
    var $receiver_0 = new Object_init();
    if ($receiver.family != null)
      $receiver_0.family = $receiver.family;
    if ($receiver.size != null)
      $receiver_0.size = $receiver.size;
    if ($receiver.style != null)
      $receiver_0.style = $receiver.style;
    if ($receiver.weight != null)
      $receiver_0.weight = $receiver.weight;
    if ($receiver.lineHeight != null)
      $receiver_0.lineHeight = $receiver.lineHeight;
    return $receiver_0;
  }
  function toJs_0($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.mode = $receiver.mode.mode_8be2vx$;
    $receiver_0.intersect = $receiver.intersect;
    $receiver_0.axis = $receiver.axis;
    $receiver_0.includeInvisible = $receiver.includeInvisible;
    return $receiver_0;
  }
  function toJs_1($receiver) {
    var tmp$;
    if ($receiver.disabled === true)
      tmp$ = false;
    else {
      var $receiver_0 = new Object_init();
      $receiver_0.duration = $receiver.duration;
      $receiver_0.easing = $receiver.easing.mode_8be2vx$;
      if ($receiver.delay != null)
        $receiver_0.delay = $receiver.delay;
      if ($receiver.loop != null)
        $receiver_0.loop = $receiver.loop;
      if ($receiver.onProgress != null)
        $receiver_0.onProgress = $receiver.onProgress;
      if ($receiver.onComplete != null)
        $receiver_0.onComplete = $receiver.onComplete;
      tmp$ = $receiver_0;
    }
    return tmp$;
  }
  function toJs_2($receiver) {
    var $receiver_0 = new Object_init();
    if ($receiver.top != null)
      $receiver_0.top = $receiver.top;
    if ($receiver.right != null)
      $receiver_0.right = $receiver.right;
    if ($receiver.bottom != null)
      $receiver_0.bottom = $receiver.bottom;
    if ($receiver.left != null)
      $receiver_0.left = $receiver.left;
    return $receiver_0;
  }
  function toJs_3($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.autoPadding = $receiver.autoPadding;
    if ($receiver.padding != null)
      $receiver_0.padding = toJs_2($receiver.padding);
    return $receiver_0;
  }
  function toJs_4($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.boxWidth = $receiver.boxWidth;
    if ($receiver.boxHeight != null)
      $receiver_0.boxHeight = $receiver.boxHeight;
    if ($receiver.color != null)
      $receiver_0.color = $receiver.color.asString();
    if ($receiver.font != null)
      $receiver_0.font = toJs($receiver.font);
    $receiver_0.padding = $receiver.padding;
    if ($receiver.generateLabels != null)
      $receiver_0.generateLabels = $receiver.generateLabels;
    if ($receiver.filter != null)
      $receiver_0.filter = $receiver.filter;
    if ($receiver.sort != null)
      $receiver_0.sort = $receiver.sort;
    $receiver_0.usePointStyle = $receiver.usePointStyle;
    if ($receiver.pointStyle != null)
      $receiver_0.pointStyle = $receiver.pointStyle.style_8be2vx$;
    if ($receiver.textAlign != null)
      $receiver_0.textAlign = $receiver.textAlign.mode_8be2vx$;
    return $receiver_0;
  }
  function toJs_5($receiver, i18nTranslator) {
    var $receiver_0 = new Object_init();
    if ($receiver.display != null)
      $receiver_0.display = $receiver.display;
    if ($receiver.color != null)
      $receiver_0.color = $receiver.color.asString();
    if ($receiver.font != null)
      $receiver_0.font = toJs($receiver.font);
    if ($receiver.padding != null)
      $receiver_0.padding = $receiver.padding;
    if ($receiver.text != null)
      $receiver_0.text = i18nTranslator($receiver.text);
    return $receiver_0;
  }
  function toJs_6($receiver, i18nTranslator) {
    var $receiver_0 = new Object_init();
    $receiver_0.display = $receiver.display;
    $receiver_0.position = $receiver.position.position_8be2vx$;
    if ($receiver.align != null)
      $receiver_0.align = $receiver.align.mode_8be2vx$;
    if ($receiver.maxHeight != null)
      $receiver_0.maxHeight = $receiver.maxHeight;
    if ($receiver.maxWidth != null)
      $receiver_0.maxWidth = $receiver.maxWidth;
    $receiver_0.fullSize = $receiver.fullSize;
    $receiver_0.reverse = $receiver.reverse;
    if ($receiver.labels != null)
      $receiver_0.labels = toJs_4($receiver.labels);
    if ($receiver.rtl != null)
      $receiver_0.rtl = $receiver.rtl;
    if ($receiver.textDirection != null)
      $receiver_0.textDirection = $receiver.textDirection.mode_8be2vx$;
    if ($receiver.title != null)
      $receiver_0.title = toJs_5($receiver.title, i18nTranslator);
    if ($receiver.onClick != null)
      $receiver_0.onClick = $receiver.onClick;
    if ($receiver.onHover != null)
      $receiver_0.onHover = $receiver.onHover;
    if ($receiver.onLeave != null)
      $receiver_0.onLeave = $receiver.onLeave;
    return $receiver_0;
  }
  function toJs_7($receiver, i18nTranslator) {
    var $receiver_0 = new Object_init();
    $receiver_0.display = $receiver.display;
    $receiver_0.position = $receiver.position.position_8be2vx$;
    $receiver_0.fontSize = $receiver_0.fontSize;
    if ($receiver_0.fontStyle != null)
      $receiver_0.fontStyle = $receiver_0.fontStyle.name;
    if ($receiver_0.fontColor != null)
      $receiver_0.fontColor = $receiver_0.fontColor.asString();
    if ($receiver_0.fontFamily != null)
      $receiver_0.fontFamily = $receiver_0.fontFamily;
    $receiver_0.padding = $receiver.padding;
    if ($receiver_0.lineHeight != null)
      $receiver_0.lineHeight = $receiver_0.lineHeight;
    if ($receiver.text != null) {
      var $receiver_1 = $receiver.text;
      var destination = ArrayList_init(collectionSizeOrDefault($receiver_1, 10));
      var tmp$;
      tmp$ = $receiver_1.iterator();
      while (tmp$.hasNext()) {
        var item = tmp$.next();
        destination.add_11rb$(i18nTranslator(item));
      }
      $receiver_0.text = copyToArray(destination);
    }if ($receiver_0.fullWidth != null)
      $receiver_0.fullWidth = $receiver_0.fullWidth;
    return $receiver_0;
  }
  function toJs_8($receiver) {
    var $receiver_0 = new Object_init();
    if ($receiver.beforeTitle != null)
      $receiver_0.beforeTitle = $receiver.beforeTitle;
    if ($receiver.title != null)
      $receiver_0.title = $receiver.title;
    if ($receiver.afterTitle != null)
      $receiver_0.afterTitle = $receiver.afterTitle;
    if ($receiver.beforeBody != null)
      $receiver_0.beforeBody = $receiver.beforeBody;
    if ($receiver.beforeLabel != null)
      $receiver_0.beforeLabel = $receiver.beforeLabel;
    if ($receiver.label != null)
      $receiver_0.label = $receiver.label;
    if ($receiver.labelColor != null)
      $receiver_0.labelColor = $receiver.labelColor;
    if ($receiver.labelTextColor != null)
      $receiver_0.labelTextColor = $receiver.labelTextColor;
    if ($receiver.afterLabel != null)
      $receiver_0.afterLabel = $receiver.afterLabel;
    if ($receiver.afterBody != null)
      $receiver_0.afterBody = $receiver.afterBody;
    if ($receiver.beforeFooter != null)
      $receiver_0.beforeFooter = $receiver.beforeFooter;
    if ($receiver.footer != null)
      $receiver_0.footer = $receiver.footer;
    if ($receiver.afterFooter != null)
      $receiver_0.afterFooter = $receiver.afterFooter;
    return $receiver_0;
  }
  function toJs_9($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.enabled = $receiver.enabled;
    if ($receiver.external != null)
      $receiver_0.external = $receiver.external;
    if ($receiver.mode != null)
      $receiver_0.mode = $receiver.mode.mode_8be2vx$;
    if ($receiver.intersect != null)
      $receiver_0.intersect = $receiver.intersect;
    if ($receiver.position != null)
      $receiver_0.position = $receiver.position.mode_8be2vx$;
    if ($receiver.callbacks != null)
      $receiver_0.callbacks = toJs_8($receiver.callbacks);
    if ($receiver.filter != null)
      $receiver_0.filter = $receiver.filter;
    if ($receiver.itemSort != null)
      $receiver_0.itemSort = $receiver.itemSort;
    if ($receiver.backgroundColor != null)
      $receiver_0.backgroundColor = $receiver.backgroundColor.asString();
    if ($receiver.titleColor != null)
      $receiver_0.titleColor = $receiver.titleColor.asString();
    if ($receiver.titleFont != null)
      $receiver_0.titleFont = toJs($receiver.titleFont);
    if ($receiver.titleAlign != null)
      $receiver_0.titleAlign = $receiver.titleAlign.mode_8be2vx$;
    if ($receiver.titleSpacing != null)
      $receiver_0.titleSpacing = $receiver.titleSpacing;
    if ($receiver.titleMarginBottom != null)
      $receiver_0.titleMarginBottom = $receiver.titleMarginBottom;
    if ($receiver.bodyColor != null)
      $receiver_0.bodyColor = $receiver.bodyColor.asString();
    if ($receiver.bodyFont != null)
      $receiver_0.bodyFont = toJs($receiver.bodyFont);
    if ($receiver.bodyAlign != null)
      $receiver_0.bodyAlign = $receiver.bodyAlign.mode_8be2vx$;
    if ($receiver.bodySpacing != null)
      $receiver_0.bodySpacing = $receiver.bodySpacing;
    if ($receiver.footerColor != null)
      $receiver_0.footerColor = $receiver.footerColor.asString();
    if ($receiver.footerFont != null)
      $receiver_0.footerFont = toJs($receiver.footerFont);
    if ($receiver.footerAlign != null)
      $receiver_0.footerAlign = $receiver.footerAlign.mode_8be2vx$;
    if ($receiver.footerSpacing != null)
      $receiver_0.footerSpacing = $receiver.footerSpacing;
    if ($receiver.footerMarginTop != null)
      $receiver_0.footerMarginTop = $receiver.footerMarginTop;
    if ($receiver.padding != null)
      $receiver_0.padding = toJs_2($receiver.padding);
    if ($receiver.caretPadding != null)
      $receiver_0.caretPadding = $receiver.caretPadding;
    if ($receiver.caretSize != null)
      $receiver_0.caretSize = $receiver.caretSize;
    if ($receiver.cornerRadius != null)
      $receiver_0.cornerRadius = $receiver.cornerRadius;
    if ($receiver.multiKeyBackground != null)
      $receiver_0.multiKeyBackground = $receiver.multiKeyBackground.asString();
    if ($receiver.displayColors != null)
      $receiver_0.displayColors = $receiver.displayColors;
    if ($receiver.boxWidth != null)
      $receiver_0.boxWidth = $receiver.boxWidth;
    if ($receiver.boxHeight != null)
      $receiver_0.boxHeight = $receiver.boxHeight;
    if ($receiver.boxPadding != null)
      $receiver_0.boxPadding = $receiver.boxPadding;
    if ($receiver.usePointStyle != null)
      $receiver_0.usePointStyle = $receiver.usePointStyle;
    if ($receiver.borderColor != null)
      $receiver_0.borderColor = $receiver.borderColor.asString();
    if ($receiver.borderWidth != null)
      $receiver_0.borderWidth = $receiver.borderWidth;
    if ($receiver.rtl != null)
      $receiver_0.rtl = $receiver.rtl;
    if ($receiver.textDirection != null)
      $receiver_0.textDirection = $receiver.textDirection.mode_8be2vx$;
    if ($receiver.xAlign != null)
      $receiver_0.xAlign = $receiver.xAlign;
    if ($receiver.yAlign != null)
      $receiver_0.yAlign = $receiver.yAlign;
    return $receiver_0;
  }
  function toJs_10($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.radius = $receiver.radius;
    $receiver_0.pointStyle = $receiver.pointStyle.style_8be2vx$;
    if ($receiver.backgroundColor != null)
      $receiver_0.backgroundColor = $receiver.backgroundColor.asString();
    $receiver_0.borderWidth = $receiver.borderWidth;
    if ($receiver.borderColor != null)
      $receiver_0.borderColor = $receiver.borderColor.asString();
    $receiver_0.hitRadius = $receiver.hitRadius;
    $receiver_0.hoverRadius = $receiver.hoverRadius;
    $receiver_0.hoverBorderWidth = $receiver.hoverBorderWidth;
    return $receiver_0;
  }
  function toJs_11($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.cubicInterpolationMode = $receiver.cubicInterpolationMode.mode_8be2vx$;
    if ($receiver.tension != null)
      $receiver_0.tension = $receiver.tension;
    if ($receiver.backgroundColor != null)
      $receiver_0.backgroundColor = $receiver.backgroundColor.asString();
    if ($receiver.borderWidth != null)
      $receiver_0.borderWidth = $receiver.borderWidth;
    if ($receiver.borderColor != null)
      $receiver_0.borderColor = $receiver.borderColor.asString();
    if ($receiver.borderCapStyle != null)
      $receiver_0.borderCapStyle = $receiver.borderCapStyle.mode_8be2vx$;
    if ($receiver.borderDash != null) {
      $receiver_0.borderDash = copyToArray($receiver.borderDash);
    }if ($receiver.borderDashOffset != null)
      $receiver_0.borderDashOffset = $receiver.borderDashOffset;
    if ($receiver.borderJoinStyle != null)
      $receiver_0.borderJoinStyle = $receiver.borderJoinStyle.mode_8be2vx$;
    if ($receiver.capBezierPoints != null)
      $receiver_0.capBezierPoints = $receiver.capBezierPoints;
    if ($receiver.fill != null)
      $receiver_0.fill = $receiver.fill;
    if ($receiver.stepped != null)
      $receiver_0.stepped = $receiver.stepped;
    return $receiver_0;
  }
  function toJs_12($receiver) {
    var $receiver_0 = new Object_init();
    if ($receiver.angle != null)
      $receiver_0.angle = $receiver.angle;
    if ($receiver.backgroundColor != null)
      $receiver_0.backgroundColor = $receiver.backgroundColor.asString();
    if ($receiver.borderAlign != null)
      $receiver_0.borderAlign = $receiver.borderAlign.mode_8be2vx$;
    if ($receiver.borderColor != null)
      $receiver_0.borderColor = $receiver.borderColor.asString();
    if ($receiver.borderWidth != null)
      $receiver_0.borderWidth = $receiver.borderWidth;
    if ($receiver.borderJoinStyle != null)
      $receiver_0.borderJoinStyle = $receiver.borderJoinStyle.mode_8be2vx$;
    return $receiver_0;
  }
  function toJs_13($receiver) {
    var $receiver_0 = new Object_init();
    if ($receiver.backgroundColor != null)
      $receiver_0.backgroundColor = $receiver.backgroundColor.asString();
    if ($receiver.borderColor != null)
      $receiver_0.borderColor = $receiver.borderColor.asString();
    if ($receiver.borderWidth != null)
      $receiver_0.borderWidth = $receiver.borderWidth;
    if ($receiver.borderSkipped != null)
      $receiver_0.borderSkipped = $receiver.borderSkipped.mode_8be2vx$;
    if ($receiver.borderRadius != null)
      $receiver_0.borderRadius = $receiver.borderRadius;
    if ($receiver.inflateAmount != null)
      $receiver_0.inflateAmount = $receiver.inflateAmount;
    if ($receiver.pointStyle != null)
      $receiver_0.pointStyle = $receiver.pointStyle.style_8be2vx$;
    return $receiver_0;
  }
  function toJs_14($receiver) {
    var $receiver_0 = new Object_init();
    if ($receiver.point != null)
      $receiver_0.point = toJs_10($receiver.point);
    if ($receiver.line != null)
      $receiver_0.line = toJs_11($receiver.line);
    if ($receiver.arc != null)
      $receiver_0.arc = toJs_12($receiver.arc);
    if ($receiver.bar != null)
      $receiver_0.bar = toJs_13($receiver.bar);
    return $receiver_0;
  }
  function toJs_15($receiver) {
    var $receiver_0 = new Object_init();
    $receiver_0.display = $receiver.display;
    if ($receiver.color != null)
      $receiver_0.color = $receiver.color.asString();
    if ($receiver.borderColor != null)
      $receiver_0.borderColor = $receiver.borderColor.asString();
    if ($receiver.borderWidth != null)
      $receiver_0.borderWidth = $receiver.borderWidth;
    if ($receiver.borderDash != null) {
      $receiver_0.borderDash = copyToArray($receiver.borderDash);
    }if ($receiver.borderDashOffset != null)
      $receiver_0.borderDashOffset = $receiver.borderDashOffset;
    if ($receiver.lineWidth != null)
      $receiver_0.lineWidth = $receiver.lineWidth;
    if ($receiver.drawBorder != null)
      $receiver_0.drawBorder = $receiver.drawBorder;
    if ($receiver.drawOnChartArea != null)
      $receiver_0.drawOnChartArea = $receiver.drawOnChartArea;
    if ($receiver.drawTicks != null)
      $receiver_0.drawTicks = $receiver.drawTicks;
    if ($receiver.offset != null)
      $receiver_0.offset = $receiver.offset;
    if ($receiver.tickLength != null)
      $receiver_0.tickLength = $receiver.tickLength;
    if ($receiver.tickWidth != null)
      $receiver_0.tickWidth = $receiver.tickWidth;
    if ($receiver.tickColor != null)
      $receiver_0.tickColor = $receiver.tickColor.asString();
    if ($receiver.tickBorderDash != null) {
      $receiver_0.tickBorderDash = copyToArray($receiver.tickBorderDash);
    }if ($receiver.tickBorderDashOffset != null)
      $receiver_0.tickBorderDashOffset = $receiver.tickBorderDashOffset;
    if ($receiver.circular != null)
      $receiver_0.circular = $receiver.circular;
    if ($receiver.z != null)
      $receiver_0.z = $receiver.z;
    return $receiver_0;
  }
  function toJs_16($receiver, i18nTranslator) {
    var $receiver_0 = new Object_init();
    if ($receiver.display != null)
      $receiver_0.display = $receiver.display;
    if ($receiver.color != null)
      $receiver_0.color = $receiver.color.asString();
    if ($receiver.font != null)
      $receiver_0.font = toJs($receiver.font);
    if ($receiver.padding != null)
      $receiver_0.padding = toJs_2($receiver.padding);
    if ($receiver.align != null)
      $receiver_0.align = $receiver.align.mode_8be2vx$;
    if ($receiver.text != null)
      $receiver_0.text = i18nTranslator($receiver.text);
    return $receiver_0;
  }
  function toJs_17($receiver) {
    var $receiver_0 = new Object_init();
    if ($receiver.callback != null)
      $receiver_0.callback = $receiver.callback;
    $receiver_0.display = $receiver.display;
    if ($receiver.backdropColor != null)
      $receiver_0.backdropColor = $receiver.backdropColor.asString();
    if ($receiver.backdropPadding != null)
      $receiver_0.backdropPadding = toJs_2($receiver.backdropPadding);
    if ($receiver.color != null)
      $receiver_0.color = $receiver.color.asString();
    if ($receiver.font != null)
      $receiver_0.font = toJs($receiver.font);
    if ($receiver.major != null)
      $receiver_0.major = $receiver.major;
    if ($receiver.padding != null)
      $receiver_0.padding = $receiver.padding;
    if ($receiver.showLabelBackdrop != null)
      $receiver_0.showLabelBackdrop = $receiver.showLabelBackdrop;
    if ($receiver.textStrokeColor != null)
      $receiver_0.textStrokeColor = $receiver.textStrokeColor.asString();
    if ($receiver.textStrokeWidth != null)
      $receiver_0.textStrokeWidth = $receiver.textStrokeWidth;
    if ($receiver.align != null)
      $receiver_0.align = $receiver.align.mode_8be2vx$;
    if ($receiver.crossAlign != null)
      $receiver_0.crossAlign = $receiver.crossAlign.mode_8be2vx$;
    if ($receiver.sampleSize != null)
      $receiver_0.sampleSize = $receiver.sampleSize;
    if ($receiver.autoSkip != null)
      $receiver_0.autoSkip = $receiver.autoSkip;
    if ($receiver.autoSkipPadding != null)
      $receiver_0.autoSkipPadding = $receiver.autoSkipPadding;
    if ($receiver.includeBounds != null)
      $receiver_0.includeBounds = $receiver.includeBounds;
    if ($receiver.labelOffset != null)
      $receiver_0.labelOffset = $receiver.labelOffset;
    if ($receiver.maxRotation != null)
      $receiver_0.maxRotation = $receiver.maxRotation;
    if ($receiver.minRotation != null)
      $receiver_0.minRotation = $receiver.minRotation;
    if ($receiver.mirror != null)
      $receiver_0.mirror = $receiver.mirror;
    if ($receiver.count != null)
      $receiver_0.count = $receiver.count;
    if ($receiver.format != null)
      $receiver_0.format = $receiver.format;
    if ($receiver.maxTicksLimit != null)
      $receiver_0.maxTicksLimit = $receiver.maxTicksLimit;
    if ($receiver.precision != null)
      $receiver_0.precision = $receiver.precision;
    if ($receiver.stepSize != null)
      $receiver_0.stepSize = $receiver.stepSize;
    if ($receiver.source != null)
      $receiver_0.source = $receiver.source;
    return $receiver_0;
  }
  function toJs_18($receiver, i18nTranslator) {
    var $receiver_0 = new Object_init();
    if ($receiver.type != null)
      $receiver_0.type = $receiver.type.type_8be2vx$;
    if ($receiver.alignToPixels != null)
      $receiver_0.alignToPixels = $receiver.alignToPixels;
    if ($receiver.backgroundColor != null)
      $receiver_0.backgroundColor = $receiver.backgroundColor.asString();
    if ($receiver.display != null)
      $receiver_0.display = $receiver.display;
    if ($receiver.grid != null)
      $receiver_0.grid = toJs_15($receiver.grid);
    if ($receiver.min != null)
      $receiver_0.min = $receiver.min;
    if ($receiver.max != null)
      $receiver_0.max = $receiver.max;
    if ($receiver.reverse != null)
      $receiver_0.reverse = $receiver.reverse;
    if ($receiver.stacked != null)
      $receiver_0.stacked = $receiver.stacked;
    if ($receiver.suggestedMax != null)
      $receiver_0.suggestedMax = $receiver.suggestedMax;
    if ($receiver.suggestedMin != null)
      $receiver_0.suggestedMin = $receiver.suggestedMin;
    if ($receiver.ticks != null)
      $receiver_0.ticks = toJs_17($receiver.ticks);
    if ($receiver.weight != null)
      $receiver_0.weight = $receiver.max;
    if ($receiver.bounds != null)
      $receiver_0.bounds = $receiver.bounds.mode_8be2vx$;
    if ($receiver.position != null)
      $receiver_0.position = $receiver.position.position_8be2vx$;
    if ($receiver.stack != null)
      $receiver_0.stack = $receiver.stack;
    if ($receiver.stackWeight != null)
      $receiver_0.stackWeight = $receiver.stackWeight;
    if ($receiver.axis != null)
      $receiver_0.axis = $receiver.axis;
    if ($receiver.offset != null)
      $receiver_0.offset = $receiver.offset;
    if ($receiver.title != null)
      $receiver_0.title = toJs_16($receiver.title, i18nTranslator);
    if ($receiver.labels != null) {
      var $receiver_1 = $receiver.labels;
      var destination = ArrayList_init(collectionSizeOrDefault($receiver_1, 10));
      var tmp$;
      tmp$ = $receiver_1.iterator();
      while (tmp$.hasNext()) {
        var item = tmp$.next();
        destination.add_11rb$(i18nTranslator(item));
      }
      $receiver_0.labels = copyToArray(destination);
    }if ($receiver.beginAtZero != null)
      $receiver_0.beginAtZero = $receiver.beginAtZero;
    if ($receiver.grace != null)
      $receiver_0.grace = $receiver.grace;
    if ($receiver.adapters != null)
      $receiver_0.adapters = $receiver.adapters;
    if ($receiver.time != null)
      $receiver_0.time = $receiver.time;
    if ($receiver.animate != null)
      $receiver_0.animate = $receiver.animate;
    if ($receiver.angleLines != null)
      $receiver_0.angleLines = $receiver.angleLines;
    if ($receiver.pointLabels != null)
      $receiver_0.pointLabels = $receiver.pointLabels;
    if ($receiver.startAngle != null)
      $receiver_0.startAngle = $receiver.startAngle;
    return $receiver_0;
  }
  function toJs_19($receiver, i18nTranslator) {
    var $receiver_0 = new Object_init();
    if ($receiver.legend != null)
      $receiver_0.legend = toJs_6($receiver.legend, i18nTranslator);
    if ($receiver.title != null)
      $receiver_0.title = toJs_7($receiver.title, i18nTranslator);
    if ($receiver.subtitle != null)
      $receiver_0.subtitle = toJs_7($receiver.subtitle, i18nTranslator);
    if ($receiver.tooltip != null)
      $receiver_0.tooltip = toJs_9($receiver.tooltip);
    return $receiver_0;
  }
  function toJs_20($receiver, i18nTranslator) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3;
    if ($receiver.elementsDynamic != null) {
      if ($receiver.elements == null) {
        tmp$_0 = $receiver.elementsDynamic;
      } else {
        tmp$_0 = Object.assign($receiver.elementsDynamic, toJs_14($receiver.elements));
      }
    } else {
      tmp$_0 = (tmp$ = $receiver.elements) != null ? toJs_14(tmp$) : null;
    }
    var elementsTmp = tmp$_0;
    if ($receiver.scalesDynamic != null) {
      if ($receiver.scales == null) {
        tmp$_1 = $receiver.scalesDynamic;
      } else {
        var s = {};
        var tmp$_4;
        tmp$_4 = $receiver.scales.entries.iterator();
        while (tmp$_4.hasNext()) {
          var element = tmp$_4.next();
          s[element.key] = toJs_18(element.value, i18nTranslator);
        }
        tmp$_1 = Object.assign($receiver.scalesDynamic, s);
      }
    } else if ($receiver.scales != null) {
      var s_0 = {};
      var tmp$_5;
      tmp$_5 = $receiver.scales.entries.iterator();
      while (tmp$_5.hasNext()) {
        var element_0 = tmp$_5.next();
        s_0[element_0.key] = toJs_18(element_0.value, i18nTranslator);
      }
      tmp$_1 = s_0;
    } else
      tmp$_1 = null;
    var scalesTmp = tmp$_1;
    if ($receiver.pluginsDynamic != null) {
      if ($receiver.plugins == null) {
        tmp$_3 = $receiver.pluginsDynamic;
      } else {
        tmp$_3 = Object.assign($receiver.pluginsDynamic, toJs_19($receiver.plugins, i18nTranslator));
      }
    } else {
      tmp$_3 = (tmp$_2 = $receiver.plugins) != null ? toJs_19(tmp$_2, i18nTranslator) : null;
    }
    var pluginsTmp = tmp$_3;
    var $receiver_0 = new Object_init();
    var tmp$_6;
    $receiver_0.responsive = $receiver.responsive;
    $receiver_0.responsiveAnimationDuration = $receiver_0.responsiveAnimationDuration;
    if ($receiver.aspectRatio != null)
      $receiver_0.aspectRatio = $receiver.aspectRatio;
    $receiver_0.maintainAspectRatio = $receiver.maintainAspectRatio;
    if ($receiver.onResize != null)
      $receiver_0.onResize = $receiver.onResize;
    if ($receiver.resizeDelay != null)
      $receiver_0.resizeDelay = $receiver.resizeDelay;
    if ($receiver.devicePixelRatio != null)
      $receiver_0.devicePixelRatio = $receiver.devicePixelRatio;
    $receiver_0.locale = (tmp$_6 = $receiver.locale) != null ? tmp$_6 : i18n.I18n.language;
    if ($receiver.interaction != null)
      $receiver_0.interaction = toJs_0($receiver.interaction);
    if ($receiver.hover != null)
      $receiver_0.hover = toJs_0($receiver.hover);
    if ($receiver.events != null) {
      $receiver_0.events = copyToArray($receiver.events);
    }if ($receiver.onHover != null)
      $receiver_0.onHover = $receiver.onHover;
    if ($receiver.onClick != null)
      $receiver_0.onClick = $receiver.onClick;
    if ($receiver.animation != null)
      $receiver_0.animation = toJs_1($receiver.animation);
    if ($receiver.animations != null)
      $receiver_0.animations = $receiver.animations;
    if ($receiver.transitions != null)
      $receiver_0.transitions = $receiver.transitions;
    if ($receiver.layout != null)
      $receiver_0.layout = toJs_3($receiver.layout);
    if (elementsTmp != null)
      $receiver_0.elements = elementsTmp;
    if (scalesTmp != null)
      $receiver_0.scales = scalesTmp;
    if ($receiver.showLine != null)
      $receiver_0.showLine = $receiver.showLine;
    if ($receiver.spanGaps != null)
      $receiver_0.spanGaps = $receiver.spanGaps;
    if ($receiver.cutoutPercentage != null)
      $receiver_0.cutoutPercentage = $receiver.cutoutPercentage;
    if ($receiver.circumference != null)
      $receiver_0.circumference = $receiver.circumference;
    if ($receiver.rotation != null)
      $receiver_0.rotation = $receiver.rotation;
    if (pluginsTmp != null)
      $receiver_0.plugins = pluginsTmp;
    if ($receiver.datasets != null)
      $receiver_0.datasets = $receiver.datasets;
    return $receiver_0;
  }
  function DataSets(cubicInterpolationMode, backgroundColor, borderWidth, borderColor, borderCapStyle, borderDash, borderDashOffset, borderJoinStyle, borderSkipped, clip, data, fill, hoverBackgroundColor, hoverBorderColor, hoverBorderWidth, hoverBorderCapStyle, hoverBorderDash, hoverBorderDashOffset, hoverBorderJoinStyle, indexAxis, label, order, pointBorderColor, pointBackgroundColor, pointBorderWidth, pointRadius, pointHoverRadius, pointHitRadius, pointHoverBackgroundColor, pointHoverBorderColor, pointHoverBorderWidth, pointRotation, pointStyle, segment, showLine, spanGaps, stack, stepped, tension, xAxisID, yAxisID, base, barPercentage, barThickness, borderRadius, categoryPercentage, grouped, hoverBorderRadius, inflateAmount, maxBarThickness, minBarLegth, skipNull, circumference, offset, rotation, spacing, weight, hitRadius, hoverRadius, radius, borderAlign, cutout, animation, drawActiveElementsOnTop, circular) {
    if (cubicInterpolationMode === void 0)
      cubicInterpolationMode = null;
    if (backgroundColor === void 0)
      backgroundColor = null;
    if (borderWidth === void 0)
      borderWidth = null;
    if (borderColor === void 0)
      borderColor = null;
    if (borderCapStyle === void 0)
      borderCapStyle = null;
    if (borderDash === void 0)
      borderDash = null;
    if (borderDashOffset === void 0)
      borderDashOffset = null;
    if (borderJoinStyle === void 0)
      borderJoinStyle = null;
    if (borderSkipped === void 0)
      borderSkipped = null;
    if (clip === void 0)
      clip = null;
    if (data === void 0)
      data = null;
    if (fill === void 0)
      fill = null;
    if (hoverBackgroundColor === void 0)
      hoverBackgroundColor = null;
    if (hoverBorderColor === void 0)
      hoverBorderColor = null;
    if (hoverBorderWidth === void 0)
      hoverBorderWidth = null;
    if (hoverBorderCapStyle === void 0)
      hoverBorderCapStyle = null;
    if (hoverBorderDash === void 0)
      hoverBorderDash = null;
    if (hoverBorderDashOffset === void 0)
      hoverBorderDashOffset = null;
    if (hoverBorderJoinStyle === void 0)
      hoverBorderJoinStyle = null;
    if (indexAxis === void 0)
      indexAxis = null;
    if (label === void 0)
      label = null;
    if (order === void 0)
      order = null;
    if (pointBorderColor === void 0)
      pointBorderColor = null;
    if (pointBackgroundColor === void 0)
      pointBackgroundColor = null;
    if (pointBorderWidth === void 0)
      pointBorderWidth = null;
    if (pointRadius === void 0)
      pointRadius = null;
    if (pointHoverRadius === void 0)
      pointHoverRadius = null;
    if (pointHitRadius === void 0)
      pointHitRadius = null;
    if (pointHoverBackgroundColor === void 0)
      pointHoverBackgroundColor = null;
    if (pointHoverBorderColor === void 0)
      pointHoverBorderColor = null;
    if (pointHoverBorderWidth === void 0)
      pointHoverBorderWidth = null;
    if (pointRotation === void 0)
      pointRotation = null;
    if (pointStyle === void 0)
      pointStyle = null;
    if (segment === void 0)
      segment = null;
    if (showLine === void 0)
      showLine = null;
    if (spanGaps === void 0)
      spanGaps = null;
    if (stack === void 0)
      stack = null;
    if (stepped === void 0)
      stepped = null;
    if (tension === void 0)
      tension = null;
    if (xAxisID === void 0)
      xAxisID = null;
    if (yAxisID === void 0)
      yAxisID = null;
    if (base === void 0)
      base = null;
    if (barPercentage === void 0)
      barPercentage = null;
    if (barThickness === void 0)
      barThickness = null;
    if (borderRadius === void 0)
      borderRadius = null;
    if (categoryPercentage === void 0)
      categoryPercentage = null;
    if (grouped === void 0)
      grouped = null;
    if (hoverBorderRadius === void 0)
      hoverBorderRadius = null;
    if (inflateAmount === void 0)
      inflateAmount = null;
    if (maxBarThickness === void 0)
      maxBarThickness = null;
    if (minBarLegth === void 0)
      minBarLegth = null;
    if (skipNull === void 0)
      skipNull = null;
    if (circumference === void 0)
      circumference = null;
    if (offset === void 0)
      offset = null;
    if (rotation === void 0)
      rotation = null;
    if (spacing === void 0)
      spacing = null;
    if (weight === void 0)
      weight = null;
    if (hitRadius === void 0)
      hitRadius = null;
    if (hoverRadius === void 0)
      hoverRadius = null;
    if (radius === void 0)
      radius = null;
    if (borderAlign === void 0)
      borderAlign = null;
    if (cutout === void 0)
      cutout = null;
    if (animation === void 0)
      animation = null;
    if (drawActiveElementsOnTop === void 0)
      drawActiveElementsOnTop = null;
    if (circular === void 0)
      circular = null;
    this.cubicInterpolationMode = cubicInterpolationMode;
    this.backgroundColor = backgroundColor;
    this.borderWidth = borderWidth;
    this.borderColor = borderColor;
    this.borderCapStyle = borderCapStyle;
    this.borderDash = borderDash;
    this.borderDashOffset = borderDashOffset;
    this.borderJoinStyle = borderJoinStyle;
    this.borderSkipped = borderSkipped;
    this.clip = clip;
    this.data = data;
    this.fill = fill;
    this.hoverBackgroundColor = hoverBackgroundColor;
    this.hoverBorderColor = hoverBorderColor;
    this.hoverBorderWidth = hoverBorderWidth;
    this.hoverBorderCapStyle = hoverBorderCapStyle;
    this.hoverBorderDash = hoverBorderDash;
    this.hoverBorderDashOffset = hoverBorderDashOffset;
    this.hoverBorderJoinStyle = hoverBorderJoinStyle;
    this.indexAxis = indexAxis;
    this.label = label;
    this.order = order;
    this.pointBorderColor = pointBorderColor;
    this.pointBackgroundColor = pointBackgroundColor;
    this.pointBorderWidth = pointBorderWidth;
    this.pointRadius = pointRadius;
    this.pointHoverRadius = pointHoverRadius;
    this.pointHitRadius = pointHitRadius;
    this.pointHoverBackgroundColor = pointHoverBackgroundColor;
    this.pointHoverBorderColor = pointHoverBorderColor;
    this.pointHoverBorderWidth = pointHoverBorderWidth;
    this.pointRotation = pointRotation;
    this.pointStyle = pointStyle;
    this.segment = segment;
    this.showLine = showLine;
    this.spanGaps = spanGaps;
    this.stack = stack;
    this.stepped = stepped;
    this.tension = tension;
    this.xAxisID = xAxisID;
    this.yAxisID = yAxisID;
    this.base = base;
    this.barPercentage = barPercentage;
    this.barThickness = barThickness;
    this.borderRadius = borderRadius;
    this.categoryPercentage = categoryPercentage;
    this.grouped = grouped;
    this.hoverBorderRadius = hoverBorderRadius;
    this.inflateAmount = inflateAmount;
    this.maxBarThickness = maxBarThickness;
    this.minBarLegth = minBarLegth;
    this.skipNull = skipNull;
    this.circumference = circumference;
    this.offset = offset;
    this.rotation = rotation;
    this.spacing = spacing;
    this.weight = weight;
    this.hitRadius = hitRadius;
    this.hoverRadius = hoverRadius;
    this.radius = radius;
    this.borderAlign = borderAlign;
    this.cutout = cutout;
    this.animation = animation;
    this.drawActiveElementsOnTop = drawActiveElementsOnTop;
    this.circular = circular;
  }
  DataSets.$metadata$ = {kind: Kind_CLASS, simpleName: 'DataSets', interfaces: []};
  DataSets.prototype.component1 = function () {
    return this.cubicInterpolationMode;
  };
  DataSets.prototype.component2 = function () {
    return this.backgroundColor;
  };
  DataSets.prototype.component3 = function () {
    return this.borderWidth;
  };
  DataSets.prototype.component4 = function () {
    return this.borderColor;
  };
  DataSets.prototype.component5 = function () {
    return this.borderCapStyle;
  };
  DataSets.prototype.component6 = function () {
    return this.borderDash;
  };
  DataSets.prototype.component7 = function () {
    return this.borderDashOffset;
  };
  DataSets.prototype.component8 = function () {
    return this.borderJoinStyle;
  };
  DataSets.prototype.component9 = function () {
    return this.borderSkipped;
  };
  DataSets.prototype.component10 = function () {
    return this.clip;
  };
  DataSets.prototype.component11 = function () {
    return this.data;
  };
  DataSets.prototype.component12 = function () {
    return this.fill;
  };
  DataSets.prototype.component13 = function () {
    return this.hoverBackgroundColor;
  };
  DataSets.prototype.component14 = function () {
    return this.hoverBorderColor;
  };
  DataSets.prototype.component15 = function () {
    return this.hoverBorderWidth;
  };
  DataSets.prototype.component16 = function () {
    return this.hoverBorderCapStyle;
  };
  DataSets.prototype.component17 = function () {
    return this.hoverBorderDash;
  };
  DataSets.prototype.component18 = function () {
    return this.hoverBorderDashOffset;
  };
  DataSets.prototype.component19 = function () {
    return this.hoverBorderJoinStyle;
  };
  DataSets.prototype.component20 = function () {
    return this.indexAxis;
  };
  DataSets.prototype.component21 = function () {
    return this.label;
  };
  DataSets.prototype.component22 = function () {
    return this.order;
  };
  DataSets.prototype.component23 = function () {
    return this.pointBorderColor;
  };
  DataSets.prototype.component24 = function () {
    return this.pointBackgroundColor;
  };
  DataSets.prototype.component25 = function () {
    return this.pointBorderWidth;
  };
  DataSets.prototype.component26 = function () {
    return this.pointRadius;
  };
  DataSets.prototype.component27 = function () {
    return this.pointHoverRadius;
  };
  DataSets.prototype.component28 = function () {
    return this.pointHitRadius;
  };
  DataSets.prototype.component29 = function () {
    return this.pointHoverBackgroundColor;
  };
  DataSets.prototype.component30 = function () {
    return this.pointHoverBorderColor;
  };
  DataSets.prototype.component31 = function () {
    return this.pointHoverBorderWidth;
  };
  DataSets.prototype.component32 = function () {
    return this.pointRotation;
  };
  DataSets.prototype.component33 = function () {
    return this.pointStyle;
  };
  DataSets.prototype.component34 = function () {
    return this.segment;
  };
  DataSets.prototype.component35 = function () {
    return this.showLine;
  };
  DataSets.prototype.component36 = function () {
    return this.spanGaps;
  };
  DataSets.prototype.component37 = function () {
    return this.stack;
  };
  DataSets.prototype.component38 = function () {
    return this.stepped;
  };
  DataSets.prototype.component39 = function () {
    return this.tension;
  };
  DataSets.prototype.component40 = function () {
    return this.xAxisID;
  };
  DataSets.prototype.component41 = function () {
    return this.yAxisID;
  };
  DataSets.prototype.component42 = function () {
    return this.base;
  };
  DataSets.prototype.component43 = function () {
    return this.barPercentage;
  };
  DataSets.prototype.component44 = function () {
    return this.barThickness;
  };
  DataSets.prototype.component45 = function () {
    return this.borderRadius;
  };
  DataSets.prototype.component46 = function () {
    return this.categoryPercentage;
  };
  DataSets.prototype.component47 = function () {
    return this.grouped;
  };
  DataSets.prototype.component48 = function () {
    return this.hoverBorderRadius;
  };
  DataSets.prototype.component49 = function () {
    return this.inflateAmount;
  };
  DataSets.prototype.component50 = function () {
    return this.maxBarThickness;
  };
  DataSets.prototype.component51 = function () {
    return this.minBarLegth;
  };
  DataSets.prototype.component52 = function () {
    return this.skipNull;
  };
  DataSets.prototype.component53 = function () {
    return this.circumference;
  };
  DataSets.prototype.component54 = function () {
    return this.offset;
  };
  DataSets.prototype.component55 = function () {
    return this.rotation;
  };
  DataSets.prototype.component56 = function () {
    return this.spacing;
  };
  DataSets.prototype.component57 = function () {
    return this.weight;
  };
  DataSets.prototype.component58 = function () {
    return this.hitRadius;
  };
  DataSets.prototype.component59 = function () {
    return this.hoverRadius;
  };
  DataSets.prototype.component60 = function () {
    return this.radius;
  };
  DataSets.prototype.component61 = function () {
    return this.borderAlign;
  };
  DataSets.prototype.component62 = function () {
    return this.cutout;
  };
  DataSets.prototype.component63 = function () {
    return this.animation;
  };
  DataSets.prototype.component64 = function () {
    return this.drawActiveElementsOnTop;
  };
  DataSets.prototype.component65 = function () {
    return this.circular;
  };
  DataSets.prototype.copy_20i9ko$ = function (cubicInterpolationMode, backgroundColor, borderWidth, borderColor, borderCapStyle, borderDash, borderDashOffset, borderJoinStyle, borderSkipped, clip, data, fill, hoverBackgroundColor, hoverBorderColor, hoverBorderWidth, hoverBorderCapStyle, hoverBorderDash, hoverBorderDashOffset, hoverBorderJoinStyle, indexAxis, label, order, pointBorderColor, pointBackgroundColor, pointBorderWidth, pointRadius, pointHoverRadius, pointHitRadius, pointHoverBackgroundColor, pointHoverBorderColor, pointHoverBorderWidth, pointRotation, pointStyle, segment, showLine, spanGaps, stack, stepped, tension, xAxisID, yAxisID, base, barPercentage, barThickness, borderRadius, categoryPercentage, grouped, hoverBorderRadius, inflateAmount, maxBarThickness, minBarLegth, skipNull, circumference, offset, rotation, spacing, weight, hitRadius, hoverRadius, radius, borderAlign, cutout, animation, drawActiveElementsOnTop, circular) {
    return new DataSets(cubicInterpolationMode === void 0 ? this.cubicInterpolationMode : cubicInterpolationMode, backgroundColor === void 0 ? this.backgroundColor : backgroundColor, borderWidth === void 0 ? this.borderWidth : borderWidth, borderColor === void 0 ? this.borderColor : borderColor, borderCapStyle === void 0 ? this.borderCapStyle : borderCapStyle, borderDash === void 0 ? this.borderDash : borderDash, borderDashOffset === void 0 ? this.borderDashOffset : borderDashOffset, borderJoinStyle === void 0 ? this.borderJoinStyle : borderJoinStyle, borderSkipped === void 0 ? this.borderSkipped : borderSkipped, clip === void 0 ? this.clip : clip, data === void 0 ? this.data : data, fill === void 0 ? this.fill : fill, hoverBackgroundColor === void 0 ? this.hoverBackgroundColor : hoverBackgroundColor, hoverBorderColor === void 0 ? this.hoverBorderColor : hoverBorderColor, hoverBorderWidth === void 0 ? this.hoverBorderWidth : hoverBorderWidth, hoverBorderCapStyle === void 0 ? this.hoverBorderCapStyle : hoverBorderCapStyle, hoverBorderDash === void 0 ? this.hoverBorderDash : hoverBorderDash, hoverBorderDashOffset === void 0 ? this.hoverBorderDashOffset : hoverBorderDashOffset, hoverBorderJoinStyle === void 0 ? this.hoverBorderJoinStyle : hoverBorderJoinStyle, indexAxis === void 0 ? this.indexAxis : indexAxis, label === void 0 ? this.label : label, order === void 0 ? this.order : order, pointBorderColor === void 0 ? this.pointBorderColor : pointBorderColor, pointBackgroundColor === void 0 ? this.pointBackgroundColor : pointBackgroundColor, pointBorderWidth === void 0 ? this.pointBorderWidth : pointBorderWidth, pointRadius === void 0 ? this.pointRadius : pointRadius, pointHoverRadius === void 0 ? this.pointHoverRadius : pointHoverRadius, pointHitRadius === void 0 ? this.pointHitRadius : pointHitRadius, pointHoverBackgroundColor === void 0 ? this.pointHoverBackgroundColor : pointHoverBackgroundColor, pointHoverBorderColor === void 0 ? this.pointHoverBorderColor : pointHoverBorderColor, pointHoverBorderWidth === void 0 ? this.pointHoverBorderWidth : pointHoverBorderWidth, pointRotation === void 0 ? this.pointRotation : pointRotation, pointStyle === void 0 ? this.pointStyle : pointStyle, segment === void 0 ? this.segment : segment, showLine === void 0 ? this.showLine : showLine, spanGaps === void 0 ? this.spanGaps : spanGaps, stack === void 0 ? this.stack : stack, stepped === void 0 ? this.stepped : stepped, tension === void 0 ? this.tension : tension, xAxisID === void 0 ? this.xAxisID : xAxisID, yAxisID === void 0 ? this.yAxisID : yAxisID, base === void 0 ? this.base : base, barPercentage === void 0 ? this.barPercentage : barPercentage, barThickness === void 0 ? this.barThickness : barThickness, borderRadius === void 0 ? this.borderRadius : borderRadius, categoryPercentage === void 0 ? this.categoryPercentage : categoryPercentage, grouped === void 0 ? this.grouped : grouped, hoverBorderRadius === void 0 ? this.hoverBorderRadius : hoverBorderRadius, inflateAmount === void 0 ? this.inflateAmount : inflateAmount, maxBarThickness === void 0 ? this.maxBarThickness : maxBarThickness, minBarLegth === void 0 ? this.minBarLegth : minBarLegth, skipNull === void 0 ? this.skipNull : skipNull, circumference === void 0 ? this.circumference : circumference, offset === void 0 ? this.offset : offset, rotation === void 0 ? this.rotation : rotation, spacing === void 0 ? this.spacing : spacing, weight === void 0 ? this.weight : weight, hitRadius === void 0 ? this.hitRadius : hitRadius, hoverRadius === void 0 ? this.hoverRadius : hoverRadius, radius === void 0 ? this.radius : radius, borderAlign === void 0 ? this.borderAlign : borderAlign, cutout === void 0 ? this.cutout : cutout, animation === void 0 ? this.animation : animation, drawActiveElementsOnTop === void 0 ? this.drawActiveElementsOnTop : drawActiveElementsOnTop, circular === void 0 ? this.circular : circular);
  };
  DataSets.prototype.toString = function () {
    return 'DataSets(cubicInterpolationMode=' + Kotlin.toString(this.cubicInterpolationMode) + (', backgroundColor=' + Kotlin.toString(this.backgroundColor)) + (', borderWidth=' + Kotlin.toString(this.borderWidth)) + (', borderColor=' + Kotlin.toString(this.borderColor)) + (', borderCapStyle=' + Kotlin.toString(this.borderCapStyle)) + (', borderDash=' + Kotlin.toString(this.borderDash)) + (', borderDashOffset=' + Kotlin.toString(this.borderDashOffset)) + (', borderJoinStyle=' + Kotlin.toString(this.borderJoinStyle)) + (', borderSkipped=' + Kotlin.toString(this.borderSkipped)) + (', clip=' + Kotlin.toString(this.clip)) + (', data=' + Kotlin.toString(this.data)) + (', fill=' + Kotlin.toString(this.fill)) + (', hoverBackgroundColor=' + Kotlin.toString(this.hoverBackgroundColor)) + (', hoverBorderColor=' + Kotlin.toString(this.hoverBorderColor)) + (', hoverBorderWidth=' + Kotlin.toString(this.hoverBorderWidth)) + (', hoverBorderCapStyle=' + Kotlin.toString(this.hoverBorderCapStyle)) + (', hoverBorderDash=' + Kotlin.toString(this.hoverBorderDash)) + (', hoverBorderDashOffset=' + Kotlin.toString(this.hoverBorderDashOffset)) + (', hoverBorderJoinStyle=' + Kotlin.toString(this.hoverBorderJoinStyle)) + (', indexAxis=' + Kotlin.toString(this.indexAxis)) + (', label=' + Kotlin.toString(this.label)) + (', order=' + Kotlin.toString(this.order)) + (', pointBorderColor=' + Kotlin.toString(this.pointBorderColor)) + (', pointBackgroundColor=' + Kotlin.toString(this.pointBackgroundColor)) + (', pointBorderWidth=' + Kotlin.toString(this.pointBorderWidth)) + (', pointRadius=' + Kotlin.toString(this.pointRadius)) + (', pointHoverRadius=' + Kotlin.toString(this.pointHoverRadius)) + (', pointHitRadius=' + Kotlin.toString(this.pointHitRadius)) + (', pointHoverBackgroundColor=' + Kotlin.toString(this.pointHoverBackgroundColor)) + (', pointHoverBorderColor=' + Kotlin.toString(this.pointHoverBorderColor)) + (', pointHoverBorderWidth=' + Kotlin.toString(this.pointHoverBorderWidth)) + (', pointRotation=' + Kotlin.toString(this.pointRotation)) + (', pointStyle=' + Kotlin.toString(this.pointStyle)) + (', segment=' + Kotlin.toString(this.segment)) + (', showLine=' + Kotlin.toString(this.showLine)) + (', spanGaps=' + Kotlin.toString(this.spanGaps)) + (', stack=' + Kotlin.toString(this.stack)) + (', stepped=' + Kotlin.toString(this.stepped)) + (', tension=' + Kotlin.toString(this.tension)) + (', xAxisID=' + Kotlin.toString(this.xAxisID)) + (', yAxisID=' + Kotlin.toString(this.yAxisID)) + (', base=' + Kotlin.toString(this.base)) + (', barPercentage=' + Kotlin.toString(this.barPercentage)) + (', barThickness=' + Kotlin.toString(this.barThickness)) + (', borderRadius=' + Kotlin.toString(this.borderRadius)) + (', categoryPercentage=' + Kotlin.toString(this.categoryPercentage)) + (', grouped=' + Kotlin.toString(this.grouped)) + (', hoverBorderRadius=' + Kotlin.toString(this.hoverBorderRadius)) + (', inflateAmount=' + Kotlin.toString(this.inflateAmount)) + (', maxBarThickness=' + Kotlin.toString(this.maxBarThickness)) + (', minBarLegth=' + Kotlin.toString(this.minBarLegth)) + (', skipNull=' + Kotlin.toString(this.skipNull)) + (', circumference=' + Kotlin.toString(this.circumference)) + (', offset=' + Kotlin.toString(this.offset)) + (', rotation=' + Kotlin.toString(this.rotation)) + (', spacing=' + Kotlin.toString(this.spacing)) + (', weight=' + Kotlin.toString(this.weight)) + (', hitRadius=' + Kotlin.toString(this.hitRadius)) + (', hoverRadius=' + Kotlin.toString(this.hoverRadius)) + (', radius=' + Kotlin.toString(this.radius)) + (', borderAlign=' + Kotlin.toString(this.borderAlign)) + (', cutout=' + Kotlin.toString(this.cutout)) + (', animation=' + Kotlin.toString(this.animation)) + (', drawActiveElementsOnTop=' + Kotlin.toString(this.drawActiveElementsOnTop)) + (', circular=' + Kotlin.toString(this.circular)) + ')';
  };
  DataSets.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.cubicInterpolationMode) | 0;
    result = result * 31 + Kotlin.hashCode(this.backgroundColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderWidth) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderCapStyle) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderDash) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderDashOffset) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderJoinStyle) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderSkipped) | 0;
    result = result * 31 + Kotlin.hashCode(this.clip) | 0;
    result = result * 31 + Kotlin.hashCode(this.data) | 0;
    result = result * 31 + Kotlin.hashCode(this.fill) | 0;
    result = result * 31 + Kotlin.hashCode(this.hoverBackgroundColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.hoverBorderColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.hoverBorderWidth) | 0;
    result = result * 31 + Kotlin.hashCode(this.hoverBorderCapStyle) | 0;
    result = result * 31 + Kotlin.hashCode(this.hoverBorderDash) | 0;
    result = result * 31 + Kotlin.hashCode(this.hoverBorderDashOffset) | 0;
    result = result * 31 + Kotlin.hashCode(this.hoverBorderJoinStyle) | 0;
    result = result * 31 + Kotlin.hashCode(this.indexAxis) | 0;
    result = result * 31 + Kotlin.hashCode(this.label) | 0;
    result = result * 31 + Kotlin.hashCode(this.order) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointBorderColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointBackgroundColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointBorderWidth) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointRadius) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointHoverRadius) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointHitRadius) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointHoverBackgroundColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointHoverBorderColor) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointHoverBorderWidth) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointRotation) | 0;
    result = result * 31 + Kotlin.hashCode(this.pointStyle) | 0;
    result = result * 31 + Kotlin.hashCode(this.segment) | 0;
    result = result * 31 + Kotlin.hashCode(this.showLine) | 0;
    result = result * 31 + Kotlin.hashCode(this.spanGaps) | 0;
    result = result * 31 + Kotlin.hashCode(this.stack) | 0;
    result = result * 31 + Kotlin.hashCode(this.stepped) | 0;
    result = result * 31 + Kotlin.hashCode(this.tension) | 0;
    result = result * 31 + Kotlin.hashCode(this.xAxisID) | 0;
    result = result * 31 + Kotlin.hashCode(this.yAxisID) | 0;
    result = result * 31 + Kotlin.hashCode(this.base) | 0;
    result = result * 31 + Kotlin.hashCode(this.barPercentage) | 0;
    result = result * 31 + Kotlin.hashCode(this.barThickness) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderRadius) | 0;
    result = result * 31 + Kotlin.hashCode(this.categoryPercentage) | 0;
    result = result * 31 + Kotlin.hashCode(this.grouped) | 0;
    result = result * 31 + Kotlin.hashCode(this.hoverBorderRadius) | 0;
    result = result * 31 + Kotlin.hashCode(this.inflateAmount) | 0;
    result = result * 31 + Kotlin.hashCode(this.maxBarThickness) | 0;
    result = result * 31 + Kotlin.hashCode(this.minBarLegth) | 0;
    result = result * 31 + Kotlin.hashCode(this.skipNull) | 0;
    result = result * 31 + Kotlin.hashCode(this.circumference) | 0;
    result = result * 31 + Kotlin.hashCode(this.offset) | 0;
    result = result * 31 + Kotlin.hashCode(this.rotation) | 0;
    result = result * 31 + Kotlin.hashCode(this.spacing) | 0;
    result = result * 31 + Kotlin.hashCode(this.weight) | 0;
    result = result * 31 + Kotlin.hashCode(this.hitRadius) | 0;
    result = result * 31 + Kotlin.hashCode(this.hoverRadius) | 0;
    result = result * 31 + Kotlin.hashCode(this.radius) | 0;
    result = result * 31 + Kotlin.hashCode(this.borderAlign) | 0;
    result = result * 31 + Kotlin.hashCode(this.cutout) | 0;
    result = result * 31 + Kotlin.hashCode(this.animation) | 0;
    result = result * 31 + Kotlin.hashCode(this.drawActiveElementsOnTop) | 0;
    result = result * 31 + Kotlin.hashCode(this.circular) | 0;
    return result;
  };
  DataSets.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.cubicInterpolationMode, other.cubicInterpolationMode) && Kotlin.equals(this.backgroundColor, other.backgroundColor) && Kotlin.equals(this.borderWidth, other.borderWidth) && Kotlin.equals(this.borderColor, other.borderColor) && Kotlin.equals(this.borderCapStyle, other.borderCapStyle) && Kotlin.equals(this.borderDash, other.borderDash) && Kotlin.equals(this.borderDashOffset, other.borderDashOffset) && Kotlin.equals(this.borderJoinStyle, other.borderJoinStyle) && Kotlin.equals(this.borderSkipped, other.borderSkipped) && Kotlin.equals(this.clip, other.clip) && Kotlin.equals(this.data, other.data) && Kotlin.equals(this.fill, other.fill) && Kotlin.equals(this.hoverBackgroundColor, other.hoverBackgroundColor) && Kotlin.equals(this.hoverBorderColor, other.hoverBorderColor) && Kotlin.equals(this.hoverBorderWidth, other.hoverBorderWidth) && Kotlin.equals(this.hoverBorderCapStyle, other.hoverBorderCapStyle) && Kotlin.equals(this.hoverBorderDash, other.hoverBorderDash) && Kotlin.equals(this.hoverBorderDashOffset, other.hoverBorderDashOffset) && Kotlin.equals(this.hoverBorderJoinStyle, other.hoverBorderJoinStyle) && Kotlin.equals(this.indexAxis, other.indexAxis) && Kotlin.equals(this.label, other.label) && Kotlin.equals(this.order, other.order) && Kotlin.equals(this.pointBorderColor, other.pointBorderColor) && Kotlin.equals(this.pointBackgroundColor, other.pointBackgroundColor) && Kotlin.equals(this.pointBorderWidth, other.pointBorderWidth) && Kotlin.equals(this.pointRadius, other.pointRadius) && Kotlin.equals(this.pointHoverRadius, other.pointHoverRadius) && Kotlin.equals(this.pointHitRadius, other.pointHitRadius) && Kotlin.equals(this.pointHoverBackgroundColor, other.pointHoverBackgroundColor) && Kotlin.equals(this.pointHoverBorderColor, other.pointHoverBorderColor) && Kotlin.equals(this.pointHoverBorderWidth, other.pointHoverBorderWidth) && Kotlin.equals(this.pointRotation, other.pointRotation) && Kotlin.equals(this.pointStyle, other.pointStyle) && Kotlin.equals(this.segment, other.segment) && Kotlin.equals(this.showLine, other.showLine) && Kotlin.equals(this.spanGaps, other.spanGaps) && Kotlin.equals(this.stack, other.stack) && Kotlin.equals(this.stepped, other.stepped) && Kotlin.equals(this.tension, other.tension) && Kotlin.equals(this.xAxisID, other.xAxisID) && Kotlin.equals(this.yAxisID, other.yAxisID) && Kotlin.equals(this.base, other.base) && Kotlin.equals(this.barPercentage, other.barPercentage) && Kotlin.equals(this.barThickness, other.barThickness) && Kotlin.equals(this.borderRadius, other.borderRadius) && Kotlin.equals(this.categoryPercentage, other.categoryPercentage) && Kotlin.equals(this.grouped, other.grouped) && Kotlin.equals(this.hoverBorderRadius, other.hoverBorderRadius) && Kotlin.equals(this.inflateAmount, other.inflateAmount) && Kotlin.equals(this.maxBarThickness, other.maxBarThickness) && Kotlin.equals(this.minBarLegth, other.minBarLegth) && Kotlin.equals(this.skipNull, other.skipNull) && Kotlin.equals(this.circumference, other.circumference) && Kotlin.equals(this.offset, other.offset) && Kotlin.equals(this.rotation, other.rotation) && Kotlin.equals(this.spacing, other.spacing) && Kotlin.equals(this.weight, other.weight) && Kotlin.equals(this.hitRadius, other.hitRadius) && Kotlin.equals(this.hoverRadius, other.hoverRadius) && Kotlin.equals(this.radius, other.radius) && Kotlin.equals(this.borderAlign, other.borderAlign) && Kotlin.equals(this.cutout, other.cutout) && Kotlin.equals(this.animation, other.animation) && Kotlin.equals(this.drawActiveElementsOnTop, other.drawActiveElementsOnTop) && Kotlin.equals(this.circular, other.circular)))));
  };
  function toJs_21($receiver, i18nTranslator) {
    var $receiver_0 = new Object_init();
    if ($receiver.cubicInterpolationMode != null)
      $receiver_0.cubicInterpolationMode = $receiver.cubicInterpolationMode.mode_8be2vx$;
    if ($receiver.backgroundColor != null) {
      var $receiver_1 = $receiver.backgroundColor;
      var destination = ArrayList_init(collectionSizeOrDefault($receiver_1, 10));
      var tmp$;
      tmp$ = $receiver_1.iterator();
      while (tmp$.hasNext()) {
        var item = tmp$.next();
        destination.add_11rb$(item.asString());
      }
      $receiver_0.backgroundColor = checkSingleValue(copyToArray(destination));
    }if ($receiver.borderWidth != null) {
      $receiver_0.borderWidth = checkSingleValue(copyToArray($receiver.borderWidth));
    }if ($receiver.borderColor != null) {
      var $receiver_2 = $receiver.borderColor;
      var destination_0 = ArrayList_init(collectionSizeOrDefault($receiver_2, 10));
      var tmp$_0;
      tmp$_0 = $receiver_2.iterator();
      while (tmp$_0.hasNext()) {
        var item_0 = tmp$_0.next();
        destination_0.add_11rb$(item_0.asString());
      }
      $receiver_0.borderColor = checkSingleValue(copyToArray(destination_0));
    }if ($receiver.borderCapStyle != null)
      $receiver_0.borderCapStyle = $receiver.borderCapStyle.mode_8be2vx$;
    if ($receiver.borderDash != null) {
      $receiver_0.borderDash = copyToArray($receiver.borderDash);
    }if ($receiver.borderDashOffset != null)
      $receiver_0.borderDashOffset = $receiver.borderDashOffset;
    if ($receiver.borderJoinStyle != null)
      $receiver_0.borderJoinStyle = $receiver.borderJoinStyle.mode_8be2vx$;
    if ($receiver.borderSkipped != null) {
      var $receiver_3 = $receiver.borderSkipped;
      var destination_1 = ArrayList_init(collectionSizeOrDefault($receiver_3, 10));
      var tmp$_1;
      tmp$_1 = $receiver_3.iterator();
      while (tmp$_1.hasNext()) {
        var item_1 = tmp$_1.next();
        destination_1.add_11rb$(item_1.position_8be2vx$);
      }
      $receiver_0.borderSkipped = checkSingleValue(copyToArray(destination_1));
    }if ($receiver.clip != null)
      $receiver_0.clip = $receiver.clip;
    if ($receiver.data != null) {
      $receiver_0.data = copyToArray($receiver.data);
    }if ($receiver.fill != null)
      $receiver_0.fill = $receiver.fill;
    if ($receiver.hoverBackgroundColor != null) {
      var $receiver_4 = $receiver.hoverBackgroundColor;
      var destination_2 = ArrayList_init(collectionSizeOrDefault($receiver_4, 10));
      var tmp$_2;
      tmp$_2 = $receiver_4.iterator();
      while (tmp$_2.hasNext()) {
        var item_2 = tmp$_2.next();
        destination_2.add_11rb$(item_2.asString());
      }
      $receiver_0.hoverBackgroundColor = checkSingleValue(copyToArray(destination_2));
    }if ($receiver.hoverBorderColor != null) {
      var $receiver_5 = $receiver.hoverBorderColor;
      var destination_3 = ArrayList_init(collectionSizeOrDefault($receiver_5, 10));
      var tmp$_3;
      tmp$_3 = $receiver_5.iterator();
      while (tmp$_3.hasNext()) {
        var item_3 = tmp$_3.next();
        destination_3.add_11rb$(item_3.asString());
      }
      $receiver_0.hoverBorderColor = checkSingleValue(copyToArray(destination_3));
    }if ($receiver.hoverBorderWidth != null) {
      $receiver_0.hoverBorderWidth = checkSingleValue(copyToArray($receiver.hoverBorderWidth));
    }if ($receiver.hoverBorderCapStyle != null)
      $receiver_0.hoverBorderCapStyle = $receiver.hoverBorderCapStyle.mode_8be2vx$;
    if ($receiver.hoverBorderDash != null) {
      $receiver_0.hoverBorderDash = copyToArray($receiver.hoverBorderDash);
    }if ($receiver.hoverBorderDashOffset != null)
      $receiver_0.hoverBorderDashOffset = $receiver.hoverBorderDashOffset;
    if ($receiver.hoverBorderJoinStyle != null)
      $receiver_0.hoverBorderJoinStyle = $receiver.hoverBorderJoinStyle.mode_8be2vx$;
    if ($receiver.indexAxis != null)
      $receiver_0.indexAxis = $receiver.indexAxis;
    if ($receiver.label != null)
      $receiver_0.label = i18nTranslator($receiver.label);
    if ($receiver.order != null)
      $receiver_0.order = $receiver.order;
    if ($receiver.pointBorderColor != null) {
      var $receiver_6 = $receiver.pointBorderColor;
      var destination_4 = ArrayList_init(collectionSizeOrDefault($receiver_6, 10));
      var tmp$_4;
      tmp$_4 = $receiver_6.iterator();
      while (tmp$_4.hasNext()) {
        var item_4 = tmp$_4.next();
        destination_4.add_11rb$(item_4.asString());
      }
      $receiver_0.pointBorderColor = checkSingleValue(copyToArray(destination_4));
    }if ($receiver.pointBackgroundColor != null) {
      var $receiver_7 = $receiver.pointBackgroundColor;
      var destination_5 = ArrayList_init(collectionSizeOrDefault($receiver_7, 10));
      var tmp$_5;
      tmp$_5 = $receiver_7.iterator();
      while (tmp$_5.hasNext()) {
        var item_5 = tmp$_5.next();
        destination_5.add_11rb$(item_5.asString());
      }
      $receiver_0.pointBackgroundColor = checkSingleValue(copyToArray(destination_5));
    }if ($receiver.pointBorderWidth != null) {
      $receiver_0.pointBorderWidth = checkSingleValue(copyToArray($receiver.pointBorderWidth));
    }if ($receiver.pointRadius != null) {
      $receiver_0.pointRadius = checkSingleValue(copyToArray($receiver.pointRadius));
    }if ($receiver.pointHoverRadius != null) {
      $receiver_0.pointHoverRadius = checkSingleValue(copyToArray($receiver.pointHoverRadius));
    }if ($receiver.pointHitRadius != null) {
      $receiver_0.pointHitRadius = checkSingleValue(copyToArray($receiver.pointHitRadius));
    }if ($receiver.pointHoverBackgroundColor != null) {
      var $receiver_8 = $receiver.pointHoverBackgroundColor;
      var destination_6 = ArrayList_init(collectionSizeOrDefault($receiver_8, 10));
      var tmp$_6;
      tmp$_6 = $receiver_8.iterator();
      while (tmp$_6.hasNext()) {
        var item_6 = tmp$_6.next();
        destination_6.add_11rb$(item_6.asString());
      }
      $receiver_0.pointHoverBackgroundColor = checkSingleValue(copyToArray(destination_6));
    }if ($receiver.pointHoverBorderColor != null) {
      var $receiver_9 = $receiver.pointHoverBorderColor;
      var destination_7 = ArrayList_init(collectionSizeOrDefault($receiver_9, 10));
      var tmp$_7;
      tmp$_7 = $receiver_9.iterator();
      while (tmp$_7.hasNext()) {
        var item_7 = tmp$_7.next();
        destination_7.add_11rb$(item_7.asString());
      }
      $receiver_0.pointHoverBorderColor = checkSingleValue(copyToArray(destination_7));
    }if ($receiver.pointHoverBorderWidth != null) {
      $receiver_0.pointHoverBorderWidth = checkSingleValue(copyToArray($receiver.pointHoverBorderWidth));
    }if ($receiver.pointRotation != null) {
      $receiver_0.pointRotation = checkSingleValue(copyToArray($receiver.pointRotation));
    }if ($receiver.pointStyle != null) {
      var $receiver_10 = $receiver.pointStyle;
      var destination_8 = ArrayList_init(collectionSizeOrDefault($receiver_10, 10));
      var tmp$_8;
      tmp$_8 = $receiver_10.iterator();
      while (tmp$_8.hasNext()) {
        var item_8 = tmp$_8.next();
        destination_8.add_11rb$(item_8.style_8be2vx$);
      }
      $receiver_0.pointStyle = checkSingleValue(copyToArray(destination_8));
    }if ($receiver.segment != null)
      $receiver_0.segment = $receiver.segment;
    if ($receiver.showLine != null)
      $receiver_0.showLine = $receiver.showLine;
    if ($receiver.spanGaps != null)
      $receiver_0.spanGaps = $receiver.spanGaps;
    if ($receiver.stack != null)
      $receiver_0.stack = $receiver.stack;
    if ($receiver.stepped != null)
      $receiver_0.stepped = $receiver.stepped;
    if ($receiver.tension != null)
      $receiver_0.tension = $receiver.tension;
    if ($receiver.xAxisID != null)
      $receiver_0.xAxisID = $receiver.xAxisID;
    if ($receiver.yAxisID != null)
      $receiver_0.yAxisID = $receiver.yAxisID;
    if ($receiver.base != null)
      $receiver_0.base = $receiver.base;
    if ($receiver.barPercentage != null)
      $receiver_0.barPercentage = $receiver.barPercentage;
    if ($receiver.barThickness != null)
      $receiver_0.barThickness = $receiver.barThickness;
    if ($receiver.borderRadius != null) {
      $receiver_0.borderRadius = checkSingleValue(copyToArray($receiver.borderRadius));
    }if ($receiver.categoryPercentage != null)
      $receiver_0.categoryPercentage = $receiver.categoryPercentage;
    if ($receiver.grouped != null)
      $receiver_0.grouped = $receiver.grouped;
    if ($receiver.hoverBorderRadius != null) {
      $receiver_0.hoverBorderRadius = checkSingleValue(copyToArray($receiver.hoverBorderRadius));
    }if ($receiver.inflateAmount != null) {
      $receiver_0.inflateAmount = checkSingleValue(copyToArray($receiver.inflateAmount));
    }if ($receiver.maxBarThickness != null)
      $receiver_0.maxBarThickness = $receiver.maxBarThickness;
    if ($receiver.minBarLegth != null)
      $receiver_0.minBarLegth = $receiver.minBarLegth;
    if ($receiver.skipNull != null)
      $receiver_0.skipNull = $receiver.skipNull;
    if ($receiver.circumference != null)
      $receiver_0.circumference = $receiver.circumference;
    if ($receiver.offset != null) {
      $receiver_0.offset = checkSingleValue(copyToArray($receiver.offset));
    }if ($receiver.rotation != null)
      $receiver_0.rotation = $receiver.rotation;
    if ($receiver.spacing != null)
      $receiver_0.spacing = $receiver.spacing;
    if ($receiver.weight != null)
      $receiver_0.weight = $receiver.weight;
    if ($receiver.hitRadius != null) {
      $receiver_0.hitRadius = checkSingleValue(copyToArray($receiver.hitRadius));
    }if ($receiver.hoverRadius != null)
      $receiver_0.hoverRadius = $receiver.hoverRadius;
    if ($receiver.radius != null) {
      $receiver_0.radius = checkSingleValue(copyToArray($receiver.radius));
    }if ($receiver.borderAlign != null)
      $receiver_0.borderAlign = $receiver.borderAlign;
    if ($receiver.cutout != null)
      $receiver_0.cutout = $receiver.cutout;
    if ($receiver.animation != null)
      $receiver_0.animation = $receiver.animation;
    if ($receiver.drawActiveElementsOnTop != null)
      $receiver_0.drawActiveElementsOnTop = $receiver.drawActiveElementsOnTop;
    if ($receiver.circular != null)
      $receiver_0.circular = $receiver.circular;
    return $receiver_0;
  }
  function Configuration(type, dataSets, labels, options, optionsDynamic, plugins) {
    if (labels === void 0)
      labels = null;
    if (options === void 0)
      options = null;
    if (optionsDynamic === void 0)
      optionsDynamic = null;
    if (plugins === void 0)
      plugins = null;
    this.type = type;
    this.dataSets = dataSets;
    this.labels = labels;
    this.options = options;
    this.optionsDynamic = optionsDynamic;
    this.plugins = plugins;
  }
  Configuration.$metadata$ = {kind: Kind_CLASS, simpleName: 'Configuration', interfaces: []};
  Configuration.prototype.component1 = function () {
    return this.type;
  };
  Configuration.prototype.component2 = function () {
    return this.dataSets;
  };
  Configuration.prototype.component3 = function () {
    return this.labels;
  };
  Configuration.prototype.component4 = function () {
    return this.options;
  };
  Configuration.prototype.component5 = function () {
    return this.optionsDynamic;
  };
  Configuration.prototype.component6 = function () {
    return this.plugins;
  };
  Configuration.prototype.copy_evgwqy$ = function (type, dataSets, labels, options, optionsDynamic, plugins) {
    return new Configuration(type === void 0 ? this.type : type, dataSets === void 0 ? this.dataSets : dataSets, labels === void 0 ? this.labels : labels, options === void 0 ? this.options : options, optionsDynamic === void 0 ? this.optionsDynamic : optionsDynamic, plugins === void 0 ? this.plugins : plugins);
  };
  Configuration.prototype.toString = function () {
    return 'Configuration(type=' + Kotlin.toString(this.type) + (', dataSets=' + Kotlin.toString(this.dataSets)) + (', labels=' + Kotlin.toString(this.labels)) + (', options=' + Kotlin.toString(this.options)) + (', optionsDynamic=' + Kotlin.toString(this.optionsDynamic)) + (', plugins=' + Kotlin.toString(this.plugins)) + ')';
  };
  Configuration.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.type) | 0;
    result = result * 31 + Kotlin.hashCode(this.dataSets) | 0;
    result = result * 31 + Kotlin.hashCode(this.labels) | 0;
    result = result * 31 + Kotlin.hashCode(this.options) | 0;
    result = result * 31 + Kotlin.hashCode(this.optionsDynamic) | 0;
    result = result * 31 + Kotlin.hashCode(this.plugins) | 0;
    return result;
  };
  Configuration.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.type, other.type) && Kotlin.equals(this.dataSets, other.dataSets) && Kotlin.equals(this.labels, other.labels) && Kotlin.equals(this.options, other.options) && Kotlin.equals(this.optionsDynamic, other.optionsDynamic) && Kotlin.equals(this.plugins, other.plugins)))));
  };
  function toJs_22($receiver, i18nTranslator) {
    var tmp$, tmp$_0, tmp$_1;
    if ($receiver.optionsDynamic != null) {
      if ($receiver.options == null) {
        tmp$_0 = $receiver.optionsDynamic;
      } else {
        tmp$_0 = Object.assign($receiver.optionsDynamic, toJs_20($receiver.options, i18nTranslator));
      }
    } else {
      tmp$_0 = (tmp$ = $receiver.options) != null ? toJs_20(tmp$, i18nTranslator) : null;
    }
    var optionsTmp = tmp$_0;
    var $receiver_0 = new Object_init();
    $receiver_0.type = $receiver.type.type_8be2vx$;
    var $receiver_1 = new Object_init();
    if ($receiver.labels != null) {
      var $receiver_2 = $receiver.labels;
      var destination = ArrayList_init(collectionSizeOrDefault($receiver_2, 10));
      var tmp$_2;
      tmp$_2 = $receiver_2.iterator();
      while (tmp$_2.hasNext()) {
        var item = tmp$_2.next();
        destination.add_11rb$(i18nTranslator(item));
      }
      $receiver_1.labels = copyToArray(destination);
    }var $receiver_3 = $receiver.dataSets;
    var destination_0 = ArrayList_init(collectionSizeOrDefault($receiver_3, 10));
    var tmp$_3;
    tmp$_3 = $receiver_3.iterator();
    while (tmp$_3.hasNext()) {
      var item_0 = tmp$_3.next();
      destination_0.add_11rb$(toJs_21(item_0, i18nTranslator));
    }
    $receiver_1.datasets = copyToArray(destination_0);
    $receiver_0.data = $receiver_1;
    if (optionsTmp != null)
      $receiver_0.options = optionsTmp;
    if ($receiver.plugins != null) {
      $receiver_0.plugins = copyToArray($receiver.plugins);
    }return Kotlin.isType(tmp$_1 = $receiver_0, Object) ? tmp$_1 : throwCCE();
  }
  function checkSingleValue($receiver) {
    var tmp$;
    if ($receiver.length === 1) {
      tmp$ = $receiver[0];
    } else {
      tmp$ = $receiver;
    }
    return tmp$;
  }
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  Object.defineProperty(package$kvision, 'ChartModule', {get: ChartModule_getInstance});
  var package$chart = package$kvision.chart || (package$kvision.chart = {});
  Object.defineProperty(Chart, 'Companion', {get: Chart$Companion_getInstance});
  package$chart.Chart = Chart;
  Object.defineProperty(ChartCanvas, 'Companion', {get: ChartCanvas$Companion_getInstance});
  package$chart.ChartCanvas = ChartCanvas;
  Object.defineProperty(ChartType, 'LINE', {get: ChartType$LINE_getInstance});
  Object.defineProperty(ChartType, 'BAR', {get: ChartType$BAR_getInstance});
  Object.defineProperty(ChartType, 'RADAR', {get: ChartType$RADAR_getInstance});
  Object.defineProperty(ChartType, 'DOUGHNUT', {get: ChartType$DOUGHNUT_getInstance});
  Object.defineProperty(ChartType, 'PIE', {get: ChartType$PIE_getInstance});
  Object.defineProperty(ChartType, 'POLARAREA', {get: ChartType$POLARAREA_getInstance});
  Object.defineProperty(ChartType, 'BUBBLE', {get: ChartType$BUBBLE_getInstance});
  Object.defineProperty(ChartType, 'SCATTER', {get: ChartType$SCATTER_getInstance});
  package$chart.ChartType = ChartType;
  $$importsForInline$$['kvision-js-legacy'] = $module$kvision_js_legacy;
  package$chart.toJs_f09jw5$ = toJs;
  package$chart.toJs_ohzxps$ = toJs_0;
  package$chart.toJs_v11qg2$ = toJs_1;
  package$chart.toJs_6d7gu4$ = toJs_2;
  package$chart.toJs_vc4xam$ = toJs_3;
  package$chart.toJs_fkcpxh$ = toJs_4;
  package$chart.toJs_kwm653$ = toJs_5;
  package$chart.toJs_vvxb8x$ = toJs_6;
  package$chart.toJs_9wxg46$ = toJs_7;
  package$chart.toJs_edkcmy$ = toJs_8;
  package$chart.toJs_mmko9t$ = toJs_9;
  package$chart.toJs_jyqai6$ = toJs_10;
  package$chart.toJs_x0mqs8$ = toJs_11;
  package$chart.toJs_pu3esw$ = toJs_12;
  package$chart.toJs_t67xpt$ = toJs_13;
  package$chart.toJs_lt0y91$ = toJs_14;
  package$chart.toJs_f23kse$ = toJs_15;
  package$chart.toJs_p5v20i$ = toJs_16;
  package$chart.toJs_mh46db$ = toJs_17;
  package$chart.toJs_70z95x$ = toJs_18;
  package$chart.toJs_5dkice$ = toJs_19;
  package$chart.toJs_7y2iho$ = toJs_20;
  package$chart.DataSets = DataSets;
  package$chart.toJs_h0iwrl$ = toJs_21;
  package$chart.Configuration = Configuration;
  package$chart.toJs_k7uxos$ = toJs_22;
  return _;
}));

//# sourceMappingURL=kvision-kvision-chart-js-legacy.js.map
